export const formatStationNumber = (
  value: number | null | undefined,
  fallback = 'Not provided',
): string => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return fallback
  const text = String(value)
  const decimals = /e/i.test(text) ? 20 : (text.split('.')[1] ?? '').length
  return new Intl.NumberFormat('en-NG', {
    maximumFractionDigits: Math.min(decimals, 20),
  }).format(value)
}

export const formatStationLitres = (value: number | null | undefined, fallback = 'Not provided') =>
  typeof value === 'number' && Number.isFinite(value) ? `${formatStationNumber(value)} L` : fallback

export const formatReportDate = (value: string | null | undefined) => {
  if (!value) return 'Not provided'
  const date = new Date(value.length === 10 ? `${value}T00:00:00Z` : value)
  if (!Number.isFinite(date.getTime())) return 'Not provided'
  return new Intl.DateTimeFormat('en-NG', {
    dateStyle: 'medium',
    timeZone: 'Africa/Lagos',
  }).format(date)
}

export const stationOperationsError = (error: unknown) => {
  const data = (
    error as {
      response?: {
        data?: {
          error?: string
          message?: string
          details?: unknown
          errors?: Array<{ errors?: string[] }>
        }
      }
    }
  )?.response?.data
  const fieldError = data?.errors?.flatMap((item) => item.errors ?? []).find(Boolean)
  const detailError =
    typeof data?.details === 'string'
      ? data.details
      : data?.details && typeof data.details === 'object'
        ? Object.values(data.details)
            .map((item) => (item as { message?: string } | null)?.message)
            .find(Boolean)
        : undefined
  return (
    fieldError ||
    detailError ||
    data?.error ||
    data?.message ||
    (error instanceof Error ? error.message : undefined) ||
    'Could not load station reports. Please try again.'
  )
}
